<template>
  <div class="col-12 col-md-7">
    <div class="mid-container">
      <NavMenu/>
      <main class="content">
          <div class="row">
            <div class="col-12">
              <div class="tittle-content">
                <img class="subtittle-img" src="../assets/img/confiamos.webp" alt="Confía en tu idea, Confiamos en ti">
              </div>
            </div>
            <div class="col-12 col-md-10">
              <p class="general-text">En el corazón de nuestra esencia, somos más que una compañía financiera; somos tu aliado en la realización de tus sueños y proyectos. En Financiera Sihusel, damos prioridad a la rapidez, la honestidad y la flexibilidad en cada paso de tu viaje financiero.</p>
              <p class="general-text">Nuestro compromiso contigo se basa en una plataforma administrativa sólida, respaldada por una estructura que está lista para convertir tus ideas en realidades. Operamos en un entorno de innovación constante, asegurando que estemos a la vanguardia para satisfacer todas tus necesidades.</p>
              <p class="general-text">Creemos en la transparencia total, porque tu confianza es fundamental. Nuestra plataforma es accesible, diseñada para que cada decisión que tomes para tus proyectos sea informada y efectiva.</p>
              <p class="general-text">En Financiera Sihusel, no solo somos una compañía financiera, somos tu socio en la búsqueda del éxito financiero. Estamos aquí para ayudarte a alcanzar tus metas, porque cuando tú triunfas, nosotros triunfamos.</p>
              <p class="btn-crealo-green"><router-link to="/Creditos/Calculadora-Credito">Cotiza tu crédito aquí</router-link></p>
            </div>
          </div>
      </main>
      <FooterSihusel/>
    </div>
  </div>
  <div class="d-none d-md-block col-4">
    <div class="right-container nosotros-slider">
    </div>
  </div>
</template>

<script>
import FooterSihusel from './FooterSihusel.vue';
import NavMenu from './NavMenu.vue';

export default {
  name: 'NosotrosComponent',
  components: {
    NavMenu,
    FooterSihusel
  }
}
</script>

